import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Logo.module.css';

import { useAppSelector } from '../../hooks/useRedux';
import { selectMenu } from '../../features/infoSlice';

import logo from '../../assets/images/logo/selpub_cloud.svg';
import { MOVE_TO_HOME, SELPUB_URL, SERVICE_NAME } from '../../constants';

interface LogoProps {
  wrapperClasses?: string[];
  src?: string;
  children?: ReactElement | null;
}

export default function Logo({ wrapperClasses, src, children }: LogoProps) {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const page =
    menu === 'login'
      ? window.location.hostname.includes('library.selpub.com')
        ? SELPUB_URL
        : '/'
      : '/home';

  return (
    <div className={cx('logo-wrapper', wrapperClasses)}>
      <Link to={page} title={MOVE_TO_HOME}>
        <img src={src || logo} alt={SERVICE_NAME} />
        <span className={cx('blind')}>{SERVICE_NAME}</span>
      </Link>
      {children}
    </div>
  );
}
